import React, { useRef } from 'react';
import { MainContainerItems, Title } from './index.styled';
import { useTranslation } from 'react-i18next';
import AutoComplete from 'src/common/refactoredComponents/form/autocomplete/AutoComplete.jsx';
import { useSelector, useDispatch } from 'react-redux';
import { getDropdownValues } from 'src/pages/receiveSets/redux/actions';
import { logErrorToConsole } from 'src/utils/util';
export default function Account({
    accountId,
    AccountTemplate,
    accountValue,
    accounts,
    handleOnfocus,
    handleInputChange,
    handleSearch,
    isFormFieldsDisabled,
    handleDisableField,
    isFieldsDisabled,
    isAccountsOptionLoading,
    getAccountOnBlur,
    setTerritoryValue,
    loading,
}) {
    const territorySelected = useSelector(
        (state) => state.receiveSetsListDataReducer.territory
    );
    const dispatch = useDispatch();
    const accountRef = useRef(null);
    const { t: translation } = useTranslation(); 

    return (
        <MainContainerItems setMarginBottom={true}>
            <Title showAstrisk={true}>
                {translation('consignment.account.details.detailsTitle')}
            </Title>
            <AutoComplete
                showScrollBar={true}
                disableClearable={false}
                inputRef={accountRef}
                boxShadow={'0px 3px 6px #00000029'}
                options={loading ? [] : accounts}
                value={accountId}
                inputValue={accountValue}
                itemTemplate={(option) => AccountTemplate(option, 'account')}
                onChange={(value,reason) => {
                    // if (isClear) {
                    //     handleOnfocus(null, 'accounts');
                    // }
                    if(reason==='clear'){
                         handleSearch('', '', reason, 'account');
                         setTerritoryValue('');
                    }
                    handleInputChange('accountId', value);
                    if (!territorySelected) {
                        dispatch(
                            getDropdownValues({
                                dropDownName: 'territories',
                                value: value.accountId,
                            })
                        );
                    }
                    if(value==='')  handleDisableField('account', true);
                }}
                hideNoOptionText={true}
                loadingText={translation('common.loadingText')}
                noOptionsText={
                    !isAccountsOptionLoading && accounts?.length === 0
                        ? translation(
                              'calendar.filterResultsPanel.noOptionText'
                          )
                        : isAccountsOptionLoading &&
                          translation('common.loadingText')
                }
                placeholder={translation(
                    'receiveSets.ReceiveSetsLoc.Account.enterAccount'
                )}
                field="accountFormattedName"
                filterField="filterValue"
                optionValue="accountId"
                id="receiveSets-receiveSetLoc-Account-account"
                onInputChange={(event, value, reset) =>{
                    if(value)
                    { 
                        handleSearch(event, value, reset, 'account');
                    }
                    else if(reset==='clear'){
                        handleSearch('', '', reset, 'account');
                    }}
                }
                loading={isAccountsOptionLoading}
                onFocus={(event) => handleOnfocus(event, 'accounts')}
                onBlur={(event) => getAccountOnBlur(event)}
                disabled={
                    // territoryId == ''
                    // ||
                    // isFormFieldsDisabled
                    false
                }
                onOpen={() => {
                    try {
                    if (
                        isFormFieldsDisabled
                        // ||
                        // territoryId == ''
                    ) {
                        handleDisableField('account', false);
                    } else {
                        handleDisableField('account', true);
                    }
                    } catch (error) {
                        logErrorToConsole(error);
                    }
                }}
                onClose={(e) => { 
                    handleDisableField('account', false);
                    // dispatch(
                    //     getDropdownValues({
                    //         dropDownName: 'territories',
                    //     })
                    // );
                }}
                open={accountId?false:isFieldsDisabled}
                readOnly={accountId}
                detailsMargin
                marginLeft={'1.5px'}
            />
            {/* {accountId &&
            isCreditCardAccount &&
            isCreditCardAccount.data.isCCAccount ? (
                <CreditCardMessageDiv>
                    <CreditCardMessageRedText
                        fontSize="12px"
                        mbFontSize="11px"
                        margin={'0 0 0 0px'}
                    >
                        {creditCardMessage}
                    </CreditCardMessageRedText>
                </CreditCardMessageDiv>
            ) : null} */}
        </MainContainerItems>
    );
}
